import React from 'react';
import { Typography } from '@mui/material';

export const DescriptionSection = ({ description }: { description: React.ReactNode }) => {
  if (typeof description === 'string') {
    return <Typography variant="body2">{description}</Typography>;
  }

  return description ?? null;
};
